import {
  AvailableCredentials,
  CredentialItem
} from 'authentication/shared/types'

export type CurrentSelections = {
  user_uuid?: string
  organization_uuid?: string
  applicationsystem_uuid?: string
}

export type ResponseOption = {
  id: string
  value: string
  label: string
}

export type ResponseFilteredOptions = {
  user_info: ResponseOption[]
  organizations_info: ResponseOption[]
  applicationsystems_info: ResponseOption[]
}

export function getFilteredOptions(
  available: AvailableCredentials,
  current: CurrentSelections
): ResponseFilteredOptions {
  const users = available.user_info ?? []
  const orgs = available.organizations_info ?? []
  const apps = available.applicationsystems_info ?? []
  const creds = available.credential_list ?? []

  if (creds.length === 0) {
    return {
      user_info: [],
      organizations_info: [],
      applicationsystems_info: []
    }
  }

  const possibleUsers = new Set(
    creds
      .filter(
        (c) =>
          (current.organization_uuid
            ? c.organization_uuid === current.organization_uuid
            : true) &&
          (current.applicationsystem_uuid
            ? c.applicationsystem_uuid === current.applicationsystem_uuid
            : true)
      )
      .map((c) => c.user_uuid)
  )

  const possibleOrgs = new Set(
    creds
      .filter(
        (c) =>
          (current.user_uuid ? c.user_uuid === current.user_uuid : true) &&
          (current.applicationsystem_uuid
            ? c.applicationsystem_uuid === current.applicationsystem_uuid
            : true)
      )
      .map((c) => c.organization_uuid)
  )

  const possibleApps = new Set(
    creds
      .filter(
        (c) =>
          (current.user_uuid ? c.user_uuid === current.user_uuid : true) &&
          (current.organization_uuid
            ? c.organization_uuid === current.organization_uuid
            : true)
      )
      .map((c) => c.applicationsystem_uuid)
  )

  function mapToOptions(items: CredentialItem[]): ResponseOption[] {
    return items.map((i) => ({
      id: i.uuid,
      value: i.uuid,
      label: `${i.sid} | ${i.des}`
    }))
  }

  return {
    user_info: mapToOptions(users.filter((u) => possibleUsers.has(u.uuid))),
    organizations_info: mapToOptions(
      orgs.filter((o) => possibleOrgs.has(o.uuid))
    ),
    applicationsystems_info: mapToOptions(
      apps.filter((a) => possibleApps.has(a.uuid))
    )
  }
}

export const getAutoSelectedValue = (
  options: ResponseOption[],
  currentValue: string,
  newValue: string
) => {
  return newValue && options.length === 1 ? options[0].id : currentValue
}

export const fieldMappings = {
  applicationsystem_uuid: {
    targetField: 'applicationsystem_uuid',
    dependentFields: [
      { field: 'organization_uuid', options: 'organizations_info' },
      { field: 'user_uuid', options: 'user_info' }
    ]
  },
  organization_uuid: {
    targetField: 'organization_uuid',
    dependentFields: [
      { field: 'applicationsystem_uuid', options: 'applicationsystems_info' },
      { field: 'user_uuid', options: 'user_info' }
    ]
  },
  user_uuid: {
    targetField: 'user_uuid',
    dependentFields: [
      { field: 'applicationsystem_uuid', options: 'applicationsystems_info' },
      { field: 'organization_uuid', options: 'organizations_info' }
    ]
  }
}
